// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"pGqJ1s","card":"_3nAIi1","cardHeading":"_16JrXE","cardTitle":"_3TVJio","titleChronicle":"IWpFJu","cardSubtitle":"_2jNMJj","cardIcon":"_2OAADr"};